'use strict';

angular.module('mean.bids').factory('taskTotalsService', ['$filter', 'CompanyFactors', 'tradeCodeService',
    function($filter, CompanyFactors, tradeCodeService) {
        var getCurrentNetPay = function(bid_hours, crew_rate, quantity, piece_rate) {
            var val = 0;

            if(bid_hours > 0) {
                val = bid_hours * crew_rate;
            } else {
                val = quantity * piece_rate;
            }

            return val;
        };
        var getHoursAllowed = function(bid_hours, current_net_pay, crew_rate) {
            var temp_value = 0;

            if(!bid_hours) bid_hours = 0;
            if(!current_net_pay) current_net_pay = 0;
            if(!crew_rate) crew_rate = 0;

            if(bid_hours === 0) {
                if(crew_rate)
                  temp_value = (current_net_pay / crew_rate);
                else
                  temp_value = 0;
            } else {
                temp_value = bid_hours;
            }

            return $filter('number')(temp_value, 2);
        };

        var getDevSubtotal = function(item, mat) {
            var value = 0;

            if(mat.is_overridden) {
                value = mat.overridden_quantity * mat.delivery_price;
            } else {
                value = mat.quantity ? mat.quantity * mat.delivery_price : getQuantityAllowed(item, mat) * mat.delivery_price;
            }

            return value;
        };

        var getMaterialTotal = function(item, mat) {
            var value;
            if(mat.is_overridden) {
                value = mat.overridden_quantity * mat.price_per_order;
            } else {
                if(mat.quantity)
                    value = mat.quantity * mat.price_per_order;
                else
                    value = getQuantityAllowed(item, mat) * mat.price_per_order;
            }

            return value;
        };

        var getQuantityAllowed = function(subtask, material) {
            if(subtask.unit === material.unit) {
                if(material.is_overridden)
                  return material.overridden_quantity;
                else {
                    if(material.quantity)
                        return material.quantity;

                    if(material.piece_per_size !== 0)
                        return subtask.quantity / material.piece_per_size;

                    return 0;
                }
            } else
              return material.quantity;

        };

        var getTrainingAndEducation = function(hours_allowed, training_and_education) {
            return hours_allowed * training_and_education;
        };

        var getEmployeeBenefits = function(hours_allowed, benefits) {
            return hours_allowed * benefits;
        };

        var getTaskTotal = function(labor, materials, equipment, costs) {
            return labor + materials + equipment;
        };

        var mergeBidAndTaskList = function(plans, trade_code, trade, revisions) {
            var return_tasks = [];
            var bid_tasks = [];
            var task_list = trade.task_list;
            var bid_list = [];//trade.bid; //current revision
            var costs = trade.costs

            _.each(revisions, function(rev) {
                if(rev > trade.revisions.length) {
                    bid_list = trade.bid;
                } else {
                    var tB = $filter('filter')(trade.revisions, {'number': rev}, true);
                    bid_list = tB[0].bid;
                    costs = tB[0].costs;
                }
                bid_tasks = [];
                _.each(plans, function(plan) {
                    //var bid_tasks = [];
                    var tasks = $filter('filter')(task_list, {
                        'trade': trade_code}, true);

                    _.each(tasks, function(task) {
                        task.plan = plan;

                        var inlist = $filter('filter')(bid_list, {
                            'task_id': task._id, 'plan_code': plan}, true);

                        if(inlist.length === 1) {
                            _.each(inlist[0].subtasks, function(subtask) {
                                var sub = $filter('filter')(task.subtasks, {
                                    '_id': subtask.task_id}, true);

                                if(sub.length === 1) {
                                    sub[0].quantity = subtask.quantity;
                                    sub[0].bid_hours = subtask.bid_hours;
                                    sub[0].labor = subtask.labor;

                                    _.each(sub[0].materials, function(material) {
                                        var mat = $filter('filter')(subtask.materials, 
                                            {'material_id': material._id}, true);

                                        if(mat.length === 1) {
                                            material.quantity = mat[0].quantity;
                                            material.price_per_order = mat[0].price_per_order;
                                            material.delivery_price = mat[0].delivery_price;
                                        } else {
                                            material.quantity = 0;
                                            material.price_per_order = 0;
                                            material.delivery_price = 0;
                                        }
                                    });

                                    _.each(sub[0].equipment, function(equipment) {
                                        var eq = $filter('filter')(subtask.equipment, 
                                            {'equipment_id': equipment._id}, true);

                                        if(eq.length === 1) {
                                            equipment.quantity = eq[0].quantity;
                                            equipment.price_per_order = eq[0].price_per_order;
                                            equipment.delivery_price = eq[0].delivery_price;
                                        } else {
                                            equipment.quantity = 0;
                                            equipment.price_per_order = 0;
                                            equipment.delivery_price = 0;
                                        }
                                    });
                                }
                            });
                        } else {
                            _.each(task.subtasks, function(subtask) {
                                subtask.quantity = 0;
                                subtask.bid_hours = 0;
                                subtask.labor = 0;

                                _.each(subtask.materials, function(material) {
                                    material.quantity = 0;
                                    material.price_per_order = 0;
                                    material.delivery_price = 0;
                                });

                                _.each(subtask.equipment, function(equipment) {
                                    equipment.quantity = 0;
                                    equipment.price_per_order = 0;
                                    equipment.delivery_price = 0;
                                });
                            });
                        }

                        bid_tasks.push(angular.copy(task));
                    });

                    getCalculations(bid_tasks, costs);
                });

                _.each(bid_tasks, function(task) {
                    task.revision = angular.copy(rev);
                    return_tasks.push(task);
                });
            });

            return return_tasks;
        };

        var getCalculations = function(tasks, factors) {
            if(!factors.equipment_tax) factors.equipment_tax = 0;
            //this is where we take a built task list and add the
            //extra calculations of items that do not get stored.
            tasks.bid_total_labor = 0;
            tasks.bid_total_materials = 0;
            tasks.bid_materials_subtotal = 0;
            tasks.bid_materials_taxes = 0;
            tasks.bid_total_equipment = 0;
            tasks.bid_equipment_subtotal = 0;
            tasks.bid_equipment_taxes = 0;
            tasks.bid_total = 0;
            tasks.bid_total_hours_allowed = 0;
            tasks.bid_mark_up = 0;
            tasks.bid_general_liability = 0;
            tasks.bid_direct_labor = 0;
            tasks.bid_payroll_taxes = 0;
            var task_total_labor = 0;
            var task_total_hours_allowed = 0;
            var task_employee_benefits = 0;
            var task_traning_and_education = 0;
            var task_hours_allowed_subtotal = 0;
            var task_current_net_pay_subtotal = 0;
            //var task_work_comp = 0;
            tasks.bid_workers_comp = 0;

            _.each(tasks, function(task) {
                task.total = 0;
                task_total_labor = 0;
                task_total_hours_allowed = 0;
                task_employee_benefits = 0;
                task_traning_and_education = 0;
                task_hours_allowed_subtotal = 0;
                task_current_net_pay_subtotal = 0;
                task.total_labor = 0;
                task.total_direct_labor = 0;
                task.total_materials = 0;
                task.total_equipment = 0;
                task.bid_mark_up = 0;
                task.bid_general_liability = 0;
                var materials_subtotal = 0;
                var materials_dev_subtotal = 0;
                var equipment_subtotal = 0;
                var equipment_dev_subtotal = 0;
                task.materials_subtotal = 0;
                task.materials_dev_subtotal = 0;
                task.equipment_subtotal = 0;
                task.equipment_dev_subtotal = 0;
                var work_comp = 0;
                task.work_comp = 0;

                //iterate over the subtasks and add up
                _.each(task.subtasks, function(subtask) {
                    subtask.employee_benefits = 0;
                    subtask.labor = 0;
                    subtask.total = 0;
                    if(!subtask.piece_per_hour_rate) {
                        subtask.current_net_pay = 
                            getCurrentNetPay(subtask.bid_hours, subtask.crew_rate, subtask.quantity, subtask.piece_rate);
                        subtask.hours_allowed = 
                            getHoursAllowed(subtask.bid_hours, subtask.current_net_pay, subtask.crew_rate);
                    } else {
                        if(subtask.bid_hours) {
                            subtask.current_net_pay = 
                                getCurrentNetPay(subtask.bid_hours, subtask.crew_rate, subtask.quantity, subtask.piece_rate);
                            subtask.hours_allowed = 
                                getHoursAllowed(subtask.bid_hours, subtask.current_net_pay, subtask.crew_rate);
                        } else {
                            subtask.hours_allowed = subtask.quantity / subtask.piece_per_hour_rate;
                            subtask.current_net_pay = subtask.hours_allowed * subtask.crew_rate;
                        }
                    }

                    if(subtask.crew_rate < factors.w_comp_break)
                        work_comp = factors.w_comp_high;
                    else
                        work_comp = factors.w_comp_low;

                    if(subtask.current_net_pay) {
                        task_current_net_pay_subtotal += subtask.current_net_pay;
                    }

                    subtask.hours_allowed = Number(subtask.hours_allowed);
                    
                    if(!subtask.current_net_pay) subtask.current_net_pay = 0;
                    if(!subtask.hours_allowed) subtask.hours_allowed = 0;
                    if(!subtask.bid_hours) subtask.bid_hours = 0;
                    if(!subtask.labor) subtask.labor = 0;
                    if(!subtask.quantity) subtask.quantity = 0;
                    if(!subtask.work_comp) subtask.work_comp = 0;
                    if(!subtask.material_total) subtask.material_total = 0;
                    if(!subtask.equipment_total) subtask.equipment_total = 0;
                    if(!subtask.material_total) subtask.material_total = 0;
                    if(!subtask.materials_subtotal) subtask.materials_subtotal = 0;
                    if(!subtask.materials_dev_subtotal) subtask.materials_dev_subtotal = 0;
                    if(!subtask.equipment_total) subtask.equipment_total = 0;
                    if(!subtask.equipment_subtotal) subtask.equipment_subtotal = 0;
                    if(!subtask.equipment_dev_subtotal) subtask.equipment_dev_subtotal = 0;
                    
                    task_hours_allowed_subtotal = parseFloat(task_hours_allowed_subtotal) + 
                        parseFloat(subtask.hours_allowed);
                    
                    task_total_labor += subtask.current_net_pay;
                    task_total_hours_allowed = parseFloat(task_total_hours_allowed) + 
                        parseFloat(subtask.hours_allowed);
                    task_total_hours_allowed.toFixed(2);

                    subtask.material_total = 0;
                    subtask.equipment_total = 0;

                    _.each(subtask.materials, function(mat) {
                        if(!mat.quantity) mat.quantity = 0;
                        if(!mat.quantity_allowed) mat.quantity_allowed = 0;
                        if(!mat.price_per_order) mat.price_per_order = 0;
                        if(!mat.piece_per_size) mat.piece_per_size = 0;
                        if(!mat.delivery_price) mat.delivery_price = 0;
                        if(!mat.material_total) mat.material_total = 0;
                        if(!mat.materials_subtotal) mat.materials_subtotal = 0;
                        if(!mat.materials_dev_subtotal) mat.materials_dev_subtotal = 0;

                        mat.quantity_allowed = getQuantityAllowed(subtask,mat);
                        
                        //basic totals
                        mat.materials_subtotal = getMaterialTotal(subtask,mat);
                        mat.materials_dev_subtotal = getDevSubtotal(subtask,mat);

                        //add delivery to subtotal
                        subtask.materials_subtotal += mat.materials_subtotal;
                        subtask.materials_dev_subtotal += getDevSubtotal(subtask,mat);
                        subtask.material_total += mat.materials_subtotal + 
                            (mat.materials_subtotal * factors.sales_tax) +
                            mat.materials_dev_subtotal;

                        task.materials_subtotal += mat.materials_subtotal;
                        task.materials_dev_subtotal += mat.materials_dev_subtotal;
                    });

                    _.each(subtask.equipment, function(mat) {
                        if(!mat.quantity) mat.quantity = 0;
                        if(!mat.quantity_allowed) mat.quantity_allowed = 0;
                        if(!mat.price_per_order) mat.price_per_order = 0;
                        if(!mat.piece_per_size) mat.piece_per_size = 0;
                        if(!mat.delivery_price) mat.delivery_price = 0;
                        if(!mat.equipment_total) mat.equipment_total = 0;
                        if(!mat.equipment_subtotal) mat.equipment_subtotal = 0;
                        if(!mat.equipment_dev_subtotal) mat.equipment_dev_subtotal = 0;

                        mat.quantity_allowed = getQuantityAllowed(subtask,mat);
                        
                        //basic totals
                        mat.equipment_subtotal = getMaterialTotal(subtask,mat);
                        mat.equipment_dev_subtotal = getDevSubtotal(subtask,mat);

                        //add delivery to subtotal
                        subtask.equipment_subtotal += mat.equipment_subtotal;
                        subtask.equipment_dev_subtotal += getDevSubtotal(subtask,mat);
                        subtask.equipment_total += mat.equipment_subtotal + 
                            (mat.equipment_subtotal * factors.equipment_tax) +
                            mat.equipment_dev_subtotal;

                        task.equipment_subtotal += mat.equipment_subtotal;
                        task.equipment_dev_subtotal += mat.equipment_dev_subtotal;
                    });

                    subtask.work_comp = subtask.current_net_pay * work_comp;
                    subtask.labor = subtask.current_net_pay + subtask.work_comp;

                    subtask.labor = subtask.labor + subtask.current_net_pay * factors.payroll_taxes;

                    task.work_comp += subtask.work_comp;
                    task.total_labor += subtask.labor;
                    task.total_direct_labor += subtask.current_net_pay;

                    subtask.bid_mark_up = (subtask.labor * factors.labor) + 
                            (subtask.material_total * factors.material) + 
                            (subtask.equipment_total * factors.equipment);

                    task.bid_mark_up += subtask.bid_mark_up;

                    subtask.general_liability = (subtask.labor + subtask.material_total + 
                        subtask.equipment_total + subtask.bid_mark_up) * factors.general_liability;

                    task.bid_general_liability += subtask.general_liability;

                    subtask.total = subtask.labor + subtask.material_total + 
                        subtask.equipment_total + subtask.bid_mark_up + subtask.general_liability;

                    task.total += subtask.total;
                });

                task.total_hours_allowed = task_total_hours_allowed;
                task.hours_allowed_subtotal = task_hours_allowed_subtotal;
                task.current_net_pay_subtotal = task_current_net_pay_subtotal;

                task.total_current_net_pay = task.current_net_pay_subtotal;
                task.total_materials =  
                    (task.materials_subtotal + (task.materials_subtotal * factors.sales_tax) +
                        task.materials_dev_subtotal);
                task.total_equipment = 
                    (task.equipment_subtotal + (task.equipment_subtotal * factors.equipment_tax) + 
                        task.equipment_dev_subtotal);

                if(!task_total_labor) task_total_labor = 0;
                if(!task.total_hours_allowed) task.total_hours_allowed = 0;
                if(!task.total_materials) task.total_materials = 0;
                if(!task.total_equipment) task.total_equipment = 0;

                tasks.bid_direct_labor += task.total_current_net_pay; //basic labor
                tasks.bid_total_hours_allowed += task.total_hours_allowed;
                tasks.bid_total_labor += task.total_labor;
                tasks.bid_total_materials += task.total_materials;
                tasks.bid_materials_subtotal += task.materials_subtotal;
                tasks.bid_total_equipment += task.total_equipment;
                tasks.bid_equipment_subtotal += task.equipment_subtotal;
                tasks.bid_workers_comp += task.work_comp;

                tasks.bid_mark_up += task.bid_mark_up;

                tasks.bid_general_liability += task.bid_general_liability;
            });

            // tasks.bid_direct_labor, tasks.bid_workers_comp, and tasks.bid_payroll_taxes
            // are used for the total labor costs popup so the user can get more detail
            tasks.bid_payroll_taxes = tasks.bid_direct_labor * factors.payroll_taxes;
            tasks.bid_materials_taxes = tasks.bid_materials_subtotal * factors.sales_tax;
            //tasks.bid_equipment_subtotal = tasks.bid_total_equipment;
            tasks.bid_equipment_taxes = tasks.bid_equipment_subtotal * factors.equipment_tax;
            console.log('equipment subtotal ' + tasks.bid_equipment_subtotal +
                ', taxes ' + tasks.bid_equipment_taxes);
            //tasks.bid_total_equipment = tasks.bid_equipment_subtotal + tasks.bid_equipment_taxes;


            //markup of all the tasks in the view
            tasks.bid_overhead_and_profit = tasks.bid_mark_up;

            tasks.bid_total = tasks.bid_total_labor + tasks.bid_total_materials + 
                tasks.bid_total_equipment + tasks.bid_overhead_and_profit + tasks.bid_general_liability;

        };

        var getSubtaskCalculations = function(subtasks, factors) {
            if(!factors.equipment_tax) factors.equipment_tax = 0;
            //iterate over the subtasks and add up
            _.each(subtasks, function(subtask) {
                subtask.employee_benefits = 0;
                subtask.labor = 0;
                subtask.total = 0;
                var work_comp = 0;

                if(!subtask.piece_per_hour_rate) {
                    subtask.current_net_pay = 
                        getCurrentNetPay(subtask.bid_hours, subtask.crew_rate, subtask.quantity, subtask.piece_rate);
                    subtask.hours_allowed = 
                        getHoursAllowed(subtask.bid_hours, subtask.current_net_pay, subtask.crew_rate);
                } else {
                    if(subtask.bid_hours) {
                        subtask.current_net_pay = 
                            getCurrentNetPay(subtask.bid_hours, subtask.crew_rate, subtask.quantity, subtask.piece_rate);
                        subtask.hours_allowed = 
                            getHoursAllowed(subtask.bid_hours, subtask.current_net_pay, subtask.crew_rate);
                    } else {
                        subtask.hours_allowed = subtask.quantity / subtask.piece_per_hour_rate;
                        subtask.current_net_pay = subtask.hours_allowed * subtask.crew_rate;
                    }
                }

                if(subtask.crew_rate < factors.w_comp_break)
                    work_comp = factors.w_comp_high;
                else
                    work_comp = factors.w_comp_low;

                subtask.hours_allowed = Number(subtask.hours_allowed);
                
                if(!subtask.current_net_pay) subtask.current_net_pay = 0;
                if(!subtask.hours_allowed) subtask.hours_allowed = 0;
                if(!subtask.bid_hours) subtask.bid_hours = 0;
                if(!subtask.labor) subtask.labor = 0;
                if(!subtask.quantity) subtask.quantity = 0;
                if(!subtask.work_comp) subtask.work_comp = 0;
                if(!subtask.material_total) subtask.material_total = 0;
                if(!subtask.materials_subtotal) subtask.materials_subtotal = 0;
                if(!subtask.materials_dev_subtotal) subtask.materials_dev_subtotal = 0;
                if(!subtask.equipment_total) subtask.equipment_total = 0;
                if(!subtask.equipment_subtotal) subtask.equipment_subtotal = 0;
                if(!subtask.equipment_dev_subtotal) subtask.equipment_dev_subtotal = 0;

                subtask.material_total = 0;
                subtask.equipment_total = 0;

                _.each(subtask.materials, function(mat) {
                    mat.quantity = 0;
                    if(!mat.quantity_allowed) mat.quantity_allowed = 0;
                    if(!mat.price_per_order) mat.price_per_order = 0;
                    if(!mat.piece_per_size) mat.piece_per_size = 0;
                    if(!mat.delivery_price) mat.delivery_price = 0;
                    if(!mat.materials_subtotal) mat.materials_subtotal = 0;
                    if(!mat.materials_dev_subtotal) mat.materials_dev_subtotal = 0;


                    mat.quantity = mat.quantity_allowed = getQuantityAllowed(subtask,mat);
                    
                    //basic totals
                    mat.materials_subtotal = getMaterialTotal(subtask,mat);
                    var taxes = mat.materials_subtotal * factors.sales_tax;
                    mat.materials_dev_subtotal = getDevSubtotal(subtask,mat);

                    //add delivery to subtotal
                    subtask.materials_subtotal += mat.materials_subtotal;
                    subtask.materials_dev_subtotal += mat.materials_dev_subtotal;
                    subtask.material_total += mat.materials_subtotal + 
                        taxes + mat.materials_dev_subtotal;

                });

                _.each(subtask.equipment, function(mat) {
                    mat.quantity = 0;
                    if(!mat.quantity_allowed) mat.quantity_allowed = 0;
                    if(!mat.price_per_order) mat.price_per_order = 0;
                    if(!mat.piece_per_size) mat.piece_per_size = 0;
                    if(!mat.delivery_price) mat.delivery_price = 0;
                    if(!mat.materials_subtotal) mat.materials_subtotal = 0;
                    if(!mat.materials_dev_subtotal) mat.materials_dev_subtotal = 0;

                    mat.quantity = mat.quantity_allowed = getQuantityAllowed(subtask,mat);
                    
                    //basic totals
                    mat.equipment_subtotal = getMaterialTotal(subtask,mat);
                    var taxes = mat.equipment_subtotal * factors.equipment_tax;
                    mat.equipment_dev_subtotal = getDevSubtotal(subtask,mat);

                    //add delivery to subtotal
                    subtask.equipment_subtotal += mat.equipment_subtotal;
                    subtask.equipment_dev_subtotal += mat.equipment_dev_subtotal;
                    subtask.equipment_total += mat.equipment_subtotal + 
                        taxes + mat.equipment_dev_subtotal;

                });

                subtask.work_comp = subtask.current_net_pay * work_comp;
                subtask.labor = subtask.current_net_pay + subtask.work_comp;

                subtask.labor = subtask.labor + subtask.current_net_pay * factors.payroll_taxes;

                subtask.bid_mark_up = (subtask.labor * factors.labor) + 
                        (subtask.material_total * factors.material) + 
                        (subtask.equipment_total * factors.equipment);

                subtask.general_liability = (subtask.labor + subtask.material_total + 
                    subtask.equipment_total + subtask.bid_mark_up) * factors.general_liability;

                subtask.total = subtask.labor + subtask.material_total + 
                    subtask.equipment_total + subtask.bid_mark_up + subtask.general_liability;
            });
        };

        return {
            getQuantityAllowed: getQuantityAllowed,
            getDevSubtotal: getDevSubtotal,
            getMaterialTotal: getMaterialTotal,
            getCurrentNetPay: getCurrentNetPay,
            getHoursAllowed: getHoursAllowed,
            getTaskTotal: getTaskTotal,
            mergeBidAndTaskList: mergeBidAndTaskList,
            getCalculations: getCalculations,
            getSubtaskCalculations: getSubtaskCalculations
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/services/task-totals-service.js